//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { compactFormat } from "@/assets/js/compactForm.js";

export default {
  name: "CircleChart",
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    title2: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    styles: {
      type: String,
      default: "bg-primary text-primary-lightest",
    },
  },
  data() {
    return {
      compactFormat,
    };
  },
  methods: {
    formatValue(value) {
      // Hack because we don't want the default (correct) thousands separator for spanish locale
      if (isNaN(value) || value < 1000) {
        return "";
      }
      return this.$n(value, {}, this.$i18n.locale === "es" ? "de" : this.$i18n.locale);
    },
  },
};
